import { render } from "./TranslationExists.vue?vue&type=template&id=746b887c"
import script from "./TranslationExists.vue?vue&type=script&lang=js"
export * from "./TranslationExists.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__